/* eslint-disable no-unused-expressions */
// import('typeface-quicksand')
// import('typeface-bebas-neue')

import 'firebase/auth'
import { onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { auth } from "./src/firebase";
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/functions'

import { RootWrapper } from './src/components/RootWrapper'

// IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
export const onClientEntry = async () => {
  // Polyfill IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    await import('intersection-observer')
    console.log('# IntersectionObserver is polyfilled!')
  }

  // Anonymous auth
  onAuthStateChanged(auth, (user) => {
    if (!user) {
      signInAnonymously(auth).catch((err) => {
        console.error("Anonymous sign-in failed:", err);
      });
    }
  });
}

export const wrapRootElement = RootWrapper

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  window.history.scrollRestoration = 'manual'
  const currentPosition = getSavedScrollPosition(location)

  if (currentPosition) {
    window.scrollTo(...currentPosition)
  } else {
    window.scrollTo(0, 0)
  }

  return false
}